import axios from 'axios';
import { USER_EMAILS_RESYNC } from 'constants/constants';

export async function resyncEmail(): Promise<any> {
  const { data } = await axios.get(USER_EMAILS_RESYNC);
  return data;
}
